/** Display aliases only: keep registry keys intact for club and artwork lookups. */
const DISPLAY_ALIASES = {
    GSW: 'GS',
    WATL: 'ATL',
    WCHI: 'CHI',
    WCON: 'CON',
    WDAL: 'DAL',
    WGSV: 'GSV',
    WIND: 'IND',
    WLV: 'LV',
    WLA: 'LA',
    WMIN: 'MIN',
    WNY: 'NY',
    WPHX: 'PHX',
    WPOR: 'POR',
    WSEA: 'SEA',
    WTOR: 'TOR',
    WWAS: 'WAS',
};
export const clubDisplayAbbreviation = (abbreviation) => DISPLAY_ALIASES[abbreviation] ?? abbreviation;
//# sourceMappingURL=club-display-abbreviation.js.map